// Simple REST helpers. Assumes your backend exposes GET /api/hotels
// Optionally supports query params for future filtering.

export const fetchHotels = async (params = {}) => {
  const url = new URL("/api/hotels", window.location.origin);
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") url.searchParams.set(k, v);
  });

  const res = await fetch(url.toString(), { credentials: "include" });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || `Failed to fetch hotels (${res.status})`);
  }
  return res.json(); // expect an array of hotel docs
};
